module.exports = __webpack_public_path__ + "dist/assets/img/motion.1dda55df.svg";